export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6 1c-.25 0-.5.095-.706.295l-4 4a.987.987 0 0 0 0 1.41l4 4a.987.987 0 0 0 1.41 0l4-4a.987.987 0 0 0 0-1.41l-4-4A1.001 1.001 0 0 0 6 1zM4.88 2.734h2L6.704 6.5h-1.41L4.88 2.734zM5.294 7.5h1.41v1.385h-1.41V7.5z"
			fill="#ED544D"
		/>
	</svg>
);
